
















import Vue, { PropType } from "vue";
import EventExperienceCard from "../EventExperienceCard/index.vue";
import ClipMixin from "@/components/Mixins/Clip/index";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "ExperienceCard",
  components: {
    EventExperienceCard
  },
  mixins: [ClipMixin],
  props: {
    eventExperiences: {
      type: Array as PropType<Props["eventExperiences"]>,
      required: true
    }
  }
});
